import Quill from 'quill';
import 'quill/dist/quill.snow.css';

export function loadRichTextEditor() {
  const editors = document.querySelectorAll('[data-rich-text-editor]');
  if (!editors.length) return;

  editors.forEach(editor => {
    const container = document.createElement('div');
    container.className = 'quill-editor';
    editor.parentNode.insertBefore(container, editor);
    editor.style.display = 'none';

    const quill = new Quill(container, {
      modules: {
        toolbar: [
          ['bold'],
          [{ 'header': 2 }],
          [{ 'list': 'bullet' }]
        ]
      },
      theme: 'snow'
    });

    quill.root.innerHTML = editor.value;

    quill.on('text-change', () => {
      editor.value = quill.root.innerHTML;
    });
  });
}
